// Add your JS customizations here
jQuery(document).ready(function($) {
	// Initiate WOW Animations
	new WOW().init();


	// Header bar scrolled
	function scrollbarState() {
		// Header bar height
		var navHeight = $('#site-header').outerHeight();

		// Extra scroll amount
		var extraHeight = 20;

		// Total trigger point
		var scrollTrigger = navHeight + extraHeight;

		if ($(document).scrollTop() > scrollTrigger) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('is-scrolled');
		} else {
			$('body').removeClass('scrolled');
			$('#site-header').removeClass('is-scrolled');
		}
	}

	scrollbarState();

	// On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

	});

	// Menu - Hamburger
	$('.hamburger-wrap').click(function () {
		// var target = $(this).data('target');

		// If any menus open (icon active)
		if ($('body').hasClass('menu-open')) {
			$('.hamburger').removeClass('is-active');

			$('body').removeClass('menu-open parent-menu-open');
			$('#parent-menu').removeClass('open');
			$('.menu-block, .sub-menu, .child-menu').removeClass('open');
			$('.hasSub a, .hasChild a').removeClass('active');


			// If none open
		} else {
			$('.hamburger').addClass('is-active');

			$('body').addClass('menu-open parent-menu-open');
			$('#parent-menu').addClass('open');
		}
	});

	// No Parent Triggers
	$('.noParent a').click(function () {

		$('body').removeClass('parent-menu-open');

	});

	// Main Menu - Desktop
	$('#header-menu-left .hasSub a, #footer-primary .hasSub a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		$('.hamburger').addClass('is-active');

		$('#header-menu-left .hasSub a').removeClass('active');
		$('.menu-block').removeClass('open');

		$(this).addClass('active');
		$(target).addClass('open');

		$('body').addClass('menu-open');
	});

	$('#header-menu-right .hasSub a, #footer-primary .hasSub a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		$('.hamburger').addClass('is-active');

		$('#header-menu-right .hasSub a').removeClass('active');
		$('.menu-block').removeClass('open');

		$(this).addClass('active');
		$(target).addClass('open');

		$('body').addClass('menu-open');
	});
	$('#desktop-menu .hasSub a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		$('#desktop-menu .hasSub a').removeClass('active');
		$('.sub-menu-column .menu-block, .child-menu-column .menu-block').removeClass('open')

		$(this).addClass('active');
		$(target).addClass('open');
	});
	$('#desktop-menu .hasChild a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		$('#desktop-menu .hasChild a').removeClass('active');
		$('.child-menu-column .menu-block').removeClass('open')

		$(this).addClass('active');
		$(target).addClass('open');
	});

	// Main Menu - Mobile
	$('#mobile-menu .hasSub > a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		if ($(target).hasClass('open')) {
			$('#mobile-menu .hasSub > a').removeClass('active');
			$('#mobile-menu .sub-menu').removeClass('open');

			$('#mobile-menu .hasChild > a').removeClass('active');
			$('#mobile-menu .child-menu').removeClass('open');
		} else {
			$('#mobile-menu .hasSub > a').removeClass('active');
			$('#mobile-menu .sub-menu').removeClass('open');

			$(this).addClass('active');
			$(target).addClass('open');
		}
	});
	$('#mobile-menu .hasChild > a').click(function (event) {
		event.preventDefault();

		var target = $(this).attr('href');

		if ($(target).hasClass('open')) {
			$('#mobile-menu .hasChild > a').removeClass('active');
			$('#mobile-menu .child-menu').removeClass('open');
		} else {
			$('#mobile-menu .hasChild > a').removeClass('active');
			$('#mobile-menu .child-menu').removeClass('open');

			$(this).addClass('active');
			$(target).addClass('open');
		}
	});


	// Menu Toggle
	if ($('.main-nav-toggle').length > 0) {
		$('.main-nav-toggle').click(function (event) {
			event.preventDefault();

			var target = $(this).attr('href');
			var assocLink = $(this).data('link');

			// console.log(assocLink);

			$('.hamburger').addClass('is-active');
			$('body').addClass('menu-open');

			$('#header-menu-left .hasSub a').removeClass('active');
			$('#header-menu-right .hasSub a').removeClass('active');
			$('.menu-block').removeClass('open');
			$(target).addClass('open');
			$(assocLink).addClass('active');
		});
	}





	// Main Menu — scroll and menu active state
	function checkScroll() {
		var threshold = $(window).width() <= 992 ? 200 : 200;

		var scrolled = $(window).scrollTop() > threshold;

		var subActive = $('.isSubMenu.active').length > 0;
		var childActive = $('.isChildMenu.active').length > 0;

		if (scrolled || subActive || childActive) {
			$('#wrapper-navbar').addClass('scroll-active');
		} else {
			$('#wrapper-navbar').removeClass('scroll-active');
		}
	}

	function lockScroll() {
		$('body').addClass('no-scroll');
	}

	function unlockScroll() {
		$('body').removeClass('no-scroll');
	}

	// Initial check
	checkScroll();

	// Re-run on scroll, resize
	$(window).on('scroll resize', checkScroll);



	// CTA Popup
	function setCookie(name, value) {
		document.cookie = name + "=" + value + "; path=/";
	}

	function getCookie(name) {
		let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	}

	// Show popup if no cookie exists
	if (!getCookie('ctaPopupDismissed')) {
		$('#cta-popup').addClass('active');
	}

	// On dismiss
	$('#dismiss_cta').on('click', function(e) {
		e.preventDefault();

		$('#cta-popup').removeClass('active');
		setCookie('ctaPopupDismissed', 'true');
	});

	// On CTA click
	$('#cta-popup a').on('click', function() {
		setCookie('ctaPopupDismissed', 'true');
	});



	// Sliders
	$('.workshops-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		fade: true,
		cssEase: 'linear',
		prevArrow: $('.workshops-arrow-left'),
		nextArrow: $('.workshops-arrow-right')
	});

	$('.team-members-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		infinite: true,
		prevArrow: $('.related-team-arrow-left'),
		nextArrow: $('.related-team-arrow-right'),
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	function equalWorkshopComingSoonHeights() {

		var maxHeight = 0;

		$('.workshops-coming-soon-slider .bg-white').css('height', '');

		$('.workshops-coming-soon-slider .bg-white').each(function () {

			var height = $(this).outerHeight();

			if (height > maxHeight) {
				maxHeight = height;
			}

		});

		$('.workshops-coming-soon-slider .bg-white').height(maxHeight);

	}

	$('.workshops-coming-soon-slider')
		.on('init', function () {
			equalWorkshopComingSoonHeights();
		})
		.slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			adaptiveHeight: false,
			prevArrow: $('.upcoming-event-arrow-left'),
			nextArrow: $('.upcoming-event-arrow-right'),
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});

	$(window).on('resize', function () {
		equalWorkshopComingSoonHeights();
	});

	$('.workshops-coming-soon-slider').on('setPosition', function () {
		equalWorkshopComingSoonHeights();
	});

	if ($('.videos-slider .outer-wrap').length > 1) {
		$('.videos-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			fade: true,
			speed: 500,
			infinite: true,
			adaptiveHeight: true,
			prevArrow: $('.workshops-youtube-arrow-left'),
			nextArrow: $('.workshops-youtube-arrow-right')
		});
	}

	if ($('.testimonial-videos-slider .outer-wrap').length > 3) {
		$('.testimonial-videos-slider').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			speed: 500,
			infinite: true,
			adaptiveHeight: true,
			prevArrow: $('.testimonials-video-youtube-arrow-left'),
			nextArrow: $('.testimonials-video-youtube-arrow-right'),
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	}

	if ($('.workshops-reviews-slider').length && $('.workshops-reviews-slider').children().length > 1) {
		$('.workshops-reviews-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			speed: 500,
			arrows: true,
			adaptiveHeight: true,
			infinite: true,
			prevArrow: $('.workshops-reviews-arrow-left'),
			nextArrow: $('.workshops-reviews-arrow-right')
		});
	}

	if ($('.schools-reviews-slider').length && $('.schools-reviews-slider').children().length > 1) {
		$('.schools-reviews-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			speed: 500,
			arrows: true,
			adaptiveHeight: true,
			infinite: true,
			prevArrow: $('.schools-reviews-arrow-left'),
			nextArrow: $('.schools-reviews-arrow-right')
		});
	}

	$('.worked-with-slider').slick({
		slidesToShow: 6,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		prevArrow: $('.worked-with-arrow-left'),
		nextArrow: $('.worked-with-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}
		]
	});

	$('.events-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		infinite: false,
		autoplay: false,
		prevArrow: $('.programme-events-arrow-left'),
		nextArrow: $('.programme-events-arrow-right'),
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1.35
				}
			}
		]
	});





	// Smooth Scroll
	$('.sticky-header a').on('click', function (e) {

		const target = $(this.hash);

		if (target.length) {

			e.preventDefault();

			$('html, body').animate({

				scrollTop: target.offset().top - 175

			}, 600);

		}

	});








	// Project Filtering and Grids
	if ($('.isotope-grid').length) {

		var $grid = $('.isotope-grid').isotope({
			itemSelector: '.isotope-item',
			layoutMode: 'masonry',
		});

	}

	$('.image-lightbox-trigger').on('click', function () {

		const index = $(this).data('index');

		$('.image-lightbox-modal').addClass('active');
		$('body').addClass('overflow-hidden');

		if (!$('.gallery-lightbox-slider').hasClass('slick-initialized')) {

			$('.gallery-lightbox-slider').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				fade: true,
				cssEase: 'linear',
				speed: 400,
				infinite: true,
				adaptiveHeight: false,
				arrows: true,
				prevArrow: $('.workshops-gallery-slider-arrow-left'),
				nextArrow: $('.workshops-gallery-slider-arrow-right'),
				initialSlide: index
			});

		} else {

			$('.gallery-lightbox-slider').slick('slickGoTo', index, true);

		}

	});

	$(document).on('click', '.image-lightbox-modal-close, .image-lightbox-modal-overlay', function () {

		if ($('.gallery-lightbox-slider').hasClass('slick-initialized')) {
			$('.gallery-lightbox-slider').slick('unslick');
		}

		$('.image-lightbox-modal').removeClass('active');
		$('body').removeClass('overflow-hidden');

	});



	// By the numbers - Number Stat Circle
	$('.number-stat').each(function() {
		var $stat = $(this);
		var amount = parseFloat($stat.data('circle-amount')) || 0;
		var $progress = $stat.find('.number-stat-circle-progress');

		if (!$progress.length) {
			return;
		}

		var radius = parseFloat($progress.attr('r'));
		var circumference = 2 * Math.PI * radius;

		$progress.css({
			'stroke-dasharray': circumference,
			'stroke-dashoffset': circumference
		});

		var element = $stat[0];

		var observer = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
				if (!entry.isIntersecting) {
					return;
				}

				$({ progress: 0 }).animate({ progress: amount }, {
					duration: 1500,
					easing: 'swing',
					step: function(now) {
						var offset = circumference - (circumference * now / 100);
						$progress.css('stroke-dashoffset', offset);
					}
				});

				observer.unobserve(element);
			});
		}, {
			threshold: 0.25
		});

		observer.observe(element);
	});

	// Bee Animation
	(function ($) {

		function initBeeFlight($wrap) {

			var $svg        = $wrap.find('svg');
			var $flightPath = $svg.find('#flightPath');
			var $bee        = $svg.find('#bee');

			if (!$flightPath.length || !$bee.length) {
				$wrap.addClass('is-ready');
				return;
			}

			var d = $flightPath.attr('d');

			// The path is really one dash per "M ... Z" chunk. Split it back apart.
			var dashStrings = d.match(/M[^M]*?Z/g) || [];

			if (!dashStrings.length) {
				$wrap.addClass('is-ready');
				return;
			}

			var svgNS = 'http://www.w3.org/2000/svg';

			var dashes = dashStrings.map(function (ds) {

				var m  = ds.match(/M\s*(-?[\d.]+)[,\s]+(-?[\d.]+)/);
				var pt = {
					x: parseFloat(m[1]),
					y: parseFloat(m[2])
				};

				var $el = $(document.createElementNS(svgNS, 'path'))
					.attr('d', ds)
					.attr('class', 'st2 bee-dash')
					.css('opacity', 0);

				// Insert BEFORE the bee so the bee always renders on top of every dash.
				$el.insertBefore($bee);

				return {
					el: $el,
					pt: pt
				};

			});

			$flightPath.remove();

			// The bee's drawn position is the END of the trail.
			var beeBox = $bee[0].getBBox();

			var beeAnchor = {
				x: beeBox.x + beeBox.width / 2,
				y: beeBox.y + beeBox.height / 2
			};

			function dist(a, b) {

				var dx = a.x - b.x;
				var dy = a.y - b.y;

				return Math.sqrt(dx * dx + dy * dy);

			}

			function angleOf(v) {
				return Math.atan2(v.y, v.x);
			}

			function angleDiff(a1, a2) {

				var diff = Math.abs(a1 - a2) % (Math.PI * 2);

				return Math.min(diff, Math.PI * 2 - diff);

			}

			var K_NEAREST   = 6;
			var TURN_WEIGHT = 5.0;

			var startIdx = 0;
			var startD = -1;

			dashes.forEach(function (dsh, i) {

				var dd = dist(dsh.pt, beeAnchor);

				if (dd > startD) {
					startD = dd;
					startIdx = i;
				}

			});

			var remaining = dashes.slice();
			var startItem = remaining.splice(startIdx, 1)[0];

			var ordered = [startItem];
			var current = startItem.pt;
			var heading = null;

			while (remaining.length) {

				var candidates = remaining
					.map(function (dsh, i) {

						return {
							i: i,
							d: dist(dsh.pt, current)
						};

					})
					.sort(function (a, b) {
						return a.d - b.d;
					})
					.slice(0, K_NEAREST);

				var bestCandI;

				if (heading === null) {

					bestCandI = candidates[0].i;

				} else {

					var bestScore = Infinity;

					candidates.forEach(function (c) {

						var pt = remaining[c.i].pt;

						var v = {
							x: pt.x - current.x,
							y: pt.y - current.y
						};

						var a = angleDiff(angleOf(v), heading);

						var score = c.d * (1 + TURN_WEIGHT * (a / Math.PI));

						if (score < bestScore) {
							bestScore = score;
							bestCandI = c.i;
						}

					});

				}

				var next = remaining.splice(bestCandI, 1)[0];

				heading = angleOf({
					x: next.pt.x - current.x,
					y: next.pt.y - current.y
				});

				current = next.pt;

				ordered.push(next);

			}

			function setBeeTransform(pt) {

				var dx = pt.x - beeAnchor.x;
				var dy = pt.y - beeAnchor.y;

				$bee.css(
					'transform',
					'translate(' + dx + 'px,' + dy + 'px)'
				);

			}

			$bee.css('transition', 'none');

			setBeeTransform(ordered[0].pt);

			requestAnimationFrame(function () {

				$wrap.addClass('is-ready');

				requestAnimationFrame(function () {

					requestAnimationFrame(playStep);

				});

			});

			var STEP_MS = 24;
			var i = 0;

			function playStep() {

				if (i >= ordered.length) return;

				var wp = ordered[i];

				$bee.css(
					'transition',
					'transform ' + STEP_MS + 'ms linear'
				);

				void $bee[0].offsetWidth;

				setBeeTransform(wp.pt);

				wp.el.css({
					transition: 'opacity .2s ease',
					opacity: 1
				});

				i++;

				setTimeout(playStep, STEP_MS);

			}

		}

		$(function () {

			$('.bee-animation-lr-wrapper .bee-flight-wrap, .bee-animation-rl-wrapper .bee-flight-wrap').each(function () {

				var $wrap = $(this);

				if ('IntersectionObserver' in window) {

					var played = false;

					var observer = new IntersectionObserver(function (entries) {

						entries.forEach(function (entry) {

							if (entry.isIntersecting && !played) {

								played = true;

								initBeeFlight($wrap);

								observer.disconnect();

							}

						});

					}, {
						threshold: 0.3
					});

					observer.observe($wrap[0]);

				} else {

					initBeeFlight($wrap);

				}

			});

		});

	})(jQuery);

	$('.categories-select2 select').select2({
		placeholder: 'Categories',
		width: '100%'
	});

	$('.categories-select2 select').on('select2:select', function () {
		var category_url = $(this).val();

		if (category_url) {
			window.location.href = category_url;
		}
	});

	$('.archive-select2 select').select2({
		placeholder: 'Archive',
		width: '100%'
	});

	$('.archive-select2 select').on('select2:select', function () {
		var archive_url = $(this).val();

		if (archive_url) {
			window.location.href = archive_url;
		}
	});




	var $filterBlock = $('.blog-filter-wrapper');

	if ($filterBlock.length) {
		var $placeholder = $('<div class="blog-filter-placeholder"></div>');
		$filterBlock.before($placeholder);

		function updateFilterBlock() {
			var windowWidth = $(window).width();

			if (windowWidth >= 992) {
				var headerHeight = $('#site-header').outerHeight() || 0;
				var blockTop = $placeholder.offset().top;
				var scrollTop = $(window).scrollTop();

				if (scrollTop >= blockTop - headerHeight) {
					if (!$filterBlock.hasClass('is-fixed')) {
						$placeholder.height($filterBlock.outerHeight());
						$filterBlock.addClass('is-fixed');
					}

					$filterBlock.css('top', headerHeight + 'px');
				} else {
					$filterBlock.removeClass('is-fixed').css('top', '');
					$placeholder.height(0);
				}
			} else {
				$filterBlock.removeClass('is-fixed').css('top', '');
				$placeholder.height(0);
			}
		}

		$(window).on('scroll resize load', updateFilterBlock);

		updateFilterBlock();
	}

});
